import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-meme-battle',
  templateUrl: './meme-battle.component.html',
  styleUrls: ['./meme-battle.component.css']
})
export class MemeBattleComponent {
  iframeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      '/assets/Tarang-meme-battle/index.html'
    );
  }
}